import { render, staticRenderFns } from "./PopupTextBody.vue?vue&type=template&id=16fa4215&scoped=true"
import script from "./PopupTextBody.vue?vue&type=script&lang=js"
export * from "./PopupTextBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa4215",
  null
  
)

export default component.exports